module.exports = __webpack_public_path__ + "media/images/cart_empty_icon-b7e1b9e9735ff2d0074312abbeb9cb21.svg";